import {
  required,
  confirmed,
  length,
  email,
  numeric,
  max,
  alpha_num,
  min_value,
  min,
  regex,
} from "vee-validate/dist/rules";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { i18n } from "@/plugins/i18n";

extend("required", {
  ...required,
  message: () => i18n.t("mandatory_field"),
});

extend("email", {
  ...email,
  message: "This field must be a valid email",
});

extend("confirmed", {
  ...confirmed,
  message: "This field confirmation does not match",
});

extend("length", {
  ...length,
  message: "This field must have 2 options",
});

extend("numeric", {
  ...numeric,
  message: () => i18n.t("validation.numeric"),
});
extend("min_value", {
  ...min_value,
  message: () => i18n.t("neg_values_not_allowed"),
});

extend("max", {
  ...max,
  message: (x, y) => `This field can contain max ${y.length} characters`,
});
extend("min", {
  ...min,
  message: (x, y) =>
    `The field length should not be less then ${y.length} characters`,
});
extend("alpha_num", {
  ...alpha_num,
  message: "This field may only contain alpha-numeric characters",
});

extend("regex", regex);

export { ValidationObserver, ValidationProvider };
